import { defineStore } from 'pinia'
import { ref } from 'vue'
import { customAlphabet } from 'nanoid'

const generateUrlSafeToken = customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', 21)

export const useDadStore = defineStore('dad', () => ({
    messengerId: ref(),
    messageComplete: ref(false),
    pushSubscription: ref(),
    rlUserId: ref(`rluser_${generateUrlSafeToken()}`),
    rlSecret: ref(`rlsecret_${generateUrlSafeToken()}`),
    rlService: ref(),
    rlServices: ref([]),
    rlServiceSearch: ref(undefined),
    rlOptions: ref({
        globalNotifications: true
    }),
    rlConfirmedPhoneNumbers: ref({}),
    userDetailsOpen: ref(false),
    relayedMessage: ref(),
    countryCode: ref('US'),
    phoneNumber: ref({
        number: '',
        countryCode: 'US',
    }),
    relayCode: ref(),
    cryptoArrowShown: ref(false),
    gigArrowShown: ref(false),
    tours: ref({
        app: {
            skip: false,
            enabled: false,
            shownOn: undefined,
            lastStep: undefined,
            active: false
        },
    }),
    helpers: ref({
        app: {
            shownSteps: []
        }
    }),
    assignedTo: ref({}),
    language: ref('en'),
    theme: ref('light'),
    faq: ref({}),
    form: ref({}),
    optionsExpansionPanel: ref(),
    stripe: ref({
        connectAccountId: undefined,
        accountCreatePending: undefined,
        accountLinkCreatePending: undefined,
        paymentIntent: {}
    }),
    messengerNote: ref(),
    sentMessages: ref({}),
    messengers: ref({}),
    assignedJobs: ref(0),
    payWithCrypto: ref(false),
    coinbase: ref({
        paymentIntent: {}
    })
}),
    {
        persist: {
            debug: false,
        }
    }
)